import { useState } from "react";
import {
  FEATURED_COMPETITION_BG_COLOUR,
  FEATURED_COMPETITION_ENDS_TEXT_BG_COLOUR,
  FEATURED_COMPETITION_ENDS_TEXT_BORDER_COLOUR,
  FEATURED_COMPETITION_ENDS_TEXT_COLOUR,
  FEATURED_COMPETITION_HOVER_COLOUR,
} from "./header-constants";
import { CompetitionData } from "../../components/ActiveCompetitions/types";
import { getEndsInLabel } from "../../../helpers/endsIn";

const FeaturedCompetitionNavMenu = ({
  Title,
  PageUrl,
  EndDate,
  NavigationColour,
  CompetitionTypePrefix,
}: CompetitionData) => {
  const [isHovered, setIsHovered] = useState(false);
  const endsTextBorderColour =
    FEATURED_COMPETITION_ENDS_TEXT_BORDER_COLOUR[
      NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_BORDER_COLOUR
    ];
  const endsTextColour =
    FEATURED_COMPETITION_ENDS_TEXT_COLOUR[NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_COLOUR];
  const endsTextBackgroundColour =
    FEATURED_COMPETITION_ENDS_TEXT_BG_COLOUR[NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_BG_COLOUR];
  return (
    <li
      className={`cursor-pointer font-jost flex flex-col 
      ${
        !isHovered
          ? FEATURED_COMPETITION_BG_COLOUR[NavigationColour as keyof typeof FEATURED_COMPETITION_BG_COLOUR]
          : FEATURED_COMPETITION_HOVER_COLOUR[NavigationColour as keyof typeof FEATURED_COMPETITION_HOVER_COLOUR]
      } 
      border border-solid border-[#e0e0e0] rounded-lg h-[68px] py-3 px-6 gap-1 relative`}
      onClick={() => (location.href = PageUrl)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {CompetitionTypePrefix === "DC" && (
        <div
          className="absolute right-0 top-0 flex justify-center items-center gap-2 rounded-se-lg rounded-es-lg py-1 px-3"
          style={{
            background: "linear-gradient(272deg, #3A3A3A 1.71%, #111 101.82%)",
          }}>
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.91992 8.13984C1.91992 9.81879 2.57808 11.429 3.7496 12.6162C4.92112 13.8034 6.51005 14.4703 8.16684 14.4703C9.82362 14.4703 11.4125 13.8034 12.5841 12.6162C13.7556 11.429 14.4137 9.81879 14.4137 8.13984C14.4137 6.46088 13.7556 4.85069 12.5841 3.66349C11.4125 2.47629 9.82362 1.80933 8.16684 1.80933C6.51005 1.80933 4.92112 2.47629 3.7496 3.66349C2.57808 4.85069 1.91992 6.46088 1.91992 8.13984Z"
              stroke="#E7B000"
              strokeWidth="1.27778"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.1456 8.13965H15.5373M0.629883 8.13965H3.02162"
              stroke="#E7B000"
              strokeWidth="1.27778"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.52539 8.13788H9.80174M8.16357 6.47778V9.79798"
              stroke="#E7B000"
              strokeWidth="1.27778"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.22949 15.6758L8.22949 13.252"
              stroke="#FFC818"
              strokeWidth="1.27778"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.22949 3.19238L8.22949 0.768639"
              stroke="#E7B000"
              strokeWidth="1.27778"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-white font-jost text-[13px] font-medium">SKILL GAME</span>
        </div>
      )}
      <span
        className={`${endsTextBackgroundColour} w-fit text-[11px] px-2 font-medium ${endsTextColour} uppercase rounded border-2 border-solid ${endsTextBorderColour}`}>
        Ends {getEndsInLabel(EndDate)}
      </span>
      <span className="text-white font-semibold uppercase text-[14px]">{isHovered ? "Enter Now" : Title}</span>
    </li>
  );
};

export default FeaturedCompetitionNavMenu;
